export const REGISTER_FIELD_COMPANY_NAME = 'companyName';
export const REGISTER_FIELD_DUNS_ID = 'dunsId';
export const REGISTER_FIELD_COUNTRY = 'country';
export const REGISTER_FIELD_INDUSTRY = 'industry';
export const REGISTER_FIELD_FIRST_NAME = 'firstName';
export const REGISTER_FIELD_LAST_NAME = 'lastName';
export const REGISTER_FIELD_BUSINESS_EMAIL = 'businessEmail';
export const REGISTER_FIELD_PHONE = 'phone';
export const REGISTER_FIELD_ORDER_HISTORY = 'orderHistory';
export const REGISTER_FIELD_CUSTOMER_NUMBER_OLD_SHOP = 'customerNumberOldShop';
export const REGISTER_FIELD_HAS_PREVIOUS_CONTACT = 'hasPreviousContact';
export const REGISTER_FIELD_PREVIOUS_CONTACT_NAME = 'previousContactName';
export const REGISTER_FIELD_PREVIOUS_CONTACT_WHERE_MET = 'previousContactWhereMet';
export const REGISTER_FIELD_ADDITIONAL_NOTES = 'additionalNotes';
export const REGISTER_FIELD_CONSENT_ACCEPTED = 'consentAccepted';
